angular.module('leanlaw').filter('userFilter', function () {
  return function (users, included) {
    if (!users || !included) {
      return [];
    }
    return _.filter(users, u => included[u.id]);
  };
});